import { render, staticRenderFns } from "./WordCardTeaserRow.vue?vue&type=template&id=77ded6c2&scoped=true&"
import script from "./WordCardTeaserRow.vue?vue&type=script&lang=js&"
export * from "./WordCardTeaserRow.vue?vue&type=script&lang=js&"
import style0 from "./WordCardTeaserRow.vue?vue&type=style&index=0&id=77ded6c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ded6c2",
  null
  
)

export default component.exports